// Product Variations Slider
const variantScroller = function () {
  const sortElements = function () {
    const parent = document.querySelector("#variant-picker_parent");
    if (!parent) return;
    let childrenArray = Array.from(parent.children);

    childrenArray.sort(function (a, b) {
      let availA = a.getAttribute("data-available") === "true";
      let availB = b.getAttribute("data-available") === "true";

      if (availA && !availB) return -1;
      if (!availA && availB) return 1;

      let rankA = parseInt(a.getAttribute("data-ranking"));
      let rankB = parseInt(b.getAttribute("data-ranking"));
      return rankA - rankB;
    });

    childrenArray.forEach((child) => parent.appendChild(child));
  };

  sortElements();

  const options = document.querySelectorAll(
    ".custom-variant-picker .thumbnail-swatch"
  );
  const sliderWrapper = document.querySelector(
    ".custom-variant-picker .variant-picker__option-values-wrapper"
  );
  if (!sliderWrapper) return;

  const optionSize = options[0].offsetWidth;
  const resizeVariantOptions = function () {
    const resize = function (pixel) {
      options.forEach((el) => (el.style.width = `${optionSize + pixel}px`));
      options.forEach((el) => (el.style.height = `${optionSize + pixel}px`));
    };

    resize(0);
    const sliderSize = sliderWrapper.offsetWidth;
    const slideOffset = String(sliderSize / (optionSize + 8))
      .split(".")[1]
      .slice(0, 2);

    if (slideOffset < 30) {
      resize(-2);
    } else if (slideOffset > 70) {
      resize(2);
    }
  };

  resizeVariantOptions();
  window.addEventListener("resize", resizeVariantOptions);

  const carousel = document.querySelector(
    ".custom-variant-picker .variant-picker__option-values"
  );
  const scrollSteps = Number(carousel.dataset.steps);
  const left = document.querySelector(".variant-picker__nav-btn.left");
  const right = document.querySelector(".variant-picker__nav-btn.right");
  const item = document.querySelector(
    ".custom-variant-picker .thumbnail-swatch"
  );

  let slide = 0;
  const maxSlides = Math.ceil(
    document.querySelectorAll(".custom-variant-picker .thumbnail-swatch")
      .length / scrollSteps
  );

  right.addEventListener("click", function (e) {
    carousel.scrollLeft += item.clientWidth * scrollSteps;
    slide++;
    checkPosition(slide);
  });
  left.addEventListener("click", function () {
    carousel.scrollLeft -= item.clientWidth * scrollSteps;
    slide--;
    checkPosition(slide);
  });

  const checkPosition = function (slide) {
    slide === 0 ? (left.disabled = true) : (left.disabled = false);
    slide === maxSlides ? (right.disabled = true) : (right.disabled = false);
  };

  checkPosition(slide);
};
document.addEventListener("DOMContentLoaded", variantScroller);

// Countdown Timer

const countdownTimer = function () {
  if (!document.querySelector(".shopify-section--countdown-condensed")) return;

  document.querySelectorAll(".countdown-condensed__timer").forEach(function (timer) {
    console.log(timer);

    // Sticky
    const calcSticky = function () {
      const headerHeight = document.querySelector(
        ".shopify-section--header"
      ).offsetHeight;
      timer.closest(
        ".shopify-section--countdown-condensed"
      ).style.top = `${headerHeight}px`;
    };

    calcSticky();
    window.addEventListener("resize", calcSticky);

    // Timer Functionality
    const expiresAt = timer.getAttribute("expires-at");
    const startsAt = timer.getAttribute("starts-at");
    const intervalMinutes = parseInt(timer.getAttribute("expiration-intervall"), 10);

    if (!expiresAt || !startsAt) return;

    const daysEl = timer.querySelector('[type="days"]');
    const hoursEl = timer.querySelector('[type="hours"]');
    const minutesEl = timer.querySelector('[type="minutes"]');
    const secondsEl = timer.querySelector('[type="seconds"]');

    const expireDate = new Date(expiresAt).getTime();
    const startDate = new Date(startsAt).getTime();

    const show = timer.getAttribute("data-show");
    let showTimer = false;
    if (show === "false") showTimer = true;

    if (!isNaN(intervalMinutes)) {
      // Neuer Modus: Intervallbasiert
      setInterval(function () {
        const now = new Date().getTime();

        // Check if current time is within the valid range
        if (now < startDate || now > expireDate) {
          console.log(new Date(now), new Date(startDate), new Date(expireDate))
          console.log("abgelaufen")
          timer.closest(".countdown-condensed").style.maxHeight = "0px";
          timer.closest(".countdown-condensed").style.padding = "0px";
          return;
        }

        // Berechnung der verbleibenden Zeit basierend auf dem Intervall
        const intervalMilliseconds = intervalMinutes * 60 * 1000;
        const elapsedTime = (now - startDate) % intervalMilliseconds;
        const remainingTime = intervalMilliseconds - elapsedTime;

        const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

        // Aktualisiere Timer-Anzeige
        daysEl.textContent = days;
        hoursEl.textContent = hours;
        minutesEl.textContent = minutes;
        secondsEl.textContent = seconds;

        if (!showTimer) {
          timer.closest(".countdown-condensed").style.maxHeight = "300px";
          timer.closest(".countdown-condensed").style.padding = "1rem 1.25rem";
          showTimer = true;
        }
      }, 1000);
    } else {
      // Alter Modus: Standard-Countdown
      setInterval(function () {
        const now = new Date().getTime();

        // Check if current time is within the valid range
        if (now < startDate || now > expireDate) {
          timer.closest(".countdown-condensed").style.maxHeight = "0px";
          timer.closest(".countdown-condensed").style.padding = "0px";
          return;
        }

        // Calculate time remaining
        const distance = expireDate - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Hide timer if expired
        const hideTimer = function () {
          timer.closest(".countdown-condensed").style.maxHeight = "0px";
          timer.closest(".countdown-condensed").style.padding = "0px";
          showTimer = true;
        };

        if (!days && !hours && !minutes && !seconds) hideTimer();
        if (days < 0 && hours < 0 && minutes < 0 && seconds < 0) {
          hideTimer();
          showTimer = true;
        }

        // Aktualisiere Timer-Anzeige
        daysEl.textContent = days;
        hoursEl.textContent = hours;
        minutesEl.textContent = minutes;
        secondsEl.textContent = seconds;

        if (!showTimer) {
          timer.closest(".countdown-condensed").style.maxHeight = "300px";
          timer.closest(".countdown-condensed").style.padding = "1rem 1.25rem";
          showTimer = true;
        }
      }, 1000);
    }
  });
};

document.addEventListener("DOMContentLoaded", countdownTimer);

const autoAddToCart = function () {
  let dataEl = document.getElementById("auto-add-to-cart");
  if (!dataEl) return;

  const method = dataEl.getAttribute("data-method");
  const giftIDs = JSON.parse(dataEl.getAttribute("data-gift-ids"));
  const sku = dataEl.getAttribute("data-sku");
  const skus = JSON.parse(dataEl.getAttribute("data-skus"));
  const threshold = Number(dataEl.getAttribute("data-threshold")) * 100;

  let item_count = undefined;

  document.addEventListener("submit", function (e) {
    if (
      e.target.closest('form[action="/cart/add"]') ||
      e.target.closest(".shopify-product-form")
    ) {
      setTimeout(handleCartUpdate, 1000);
    }
  });

  document
    .querySelector(".cart-drawer")
    .addEventListener("input", function (e) {
      if (e.target.matches("input")) {
        setTimeout(handleCartUpdate, 1000);
      }
    });

  function addItemToCart(variantId, quantity) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Item added:", data);
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        ++item_count;
        document.querySelector(".count-bubble").textContent = `${item_count}`;
      })
      .catch((error) => {
        console.error("Error adding item:", error);
      });
  }

  function handleCartUpdate() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        console.log(cart);
        let found = false;
        if (method === "produkt") {
          skus.forEach((sku) => {
            cart.items.forEach((item) => {
              if (item.sku === sku) {
                found = true;
              }
            });
          });
        }
        // found = cart.items.some((item) => item.sku === sku);
        if (method === "bestellsumme" && cart.total_price >= threshold)
          found = true;

        if (method === "bestellsumme_produkt") {
          let sum = 0;
          skus.forEach((sku) => {
            cart.items.forEach((item) => {
              if (item.sku === sku) {
                sum += item.price * item.quantity;
              }
            });
          });
          if (sum > threshold) found = true;
        }

        item_count = cart.item_count;

        let giftAdded = false;
        cart.items.forEach((item) => {
          giftIDs.forEach((id) => {
            if (item.id == id) giftAdded = true;
          });
        });

        if (found && giftAdded === false) {
          console.log("Add to cart");
          giftIDs.forEach((id) => addItemToCart(id, 1));
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }
};

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(autoAddToCart, 50);
});
